import queryString from 'query-string';

import { ApiAreaOfFocus } from 'api/types/ApiAreaOfFocus';
import { ApiJobFunction } from 'api/types/ApiJobFunction';
import { Box } from 'components/Box';
import { AnchorButton } from 'components/Button/AnchorButton';
import { TileCarouselHeader } from 'components/TileCarousel';
import { objectEmpty } from 'utils/functional';
import { listingSearchHomePath } from 'utils/searchHomePages';

import { CmsAmpRecommendedJobCard } from './CmsAmpRecommendedJobCard';

type AmpCmsRecommendedJobsProps = {
  headline: string | null | undefined;
  layout: 'SLIM' | 'REGULAR';
  source: 'RECOMMENDED_JOBS_CHECKBOX' | 'RECOMMENDED_JOBS_BLOCK';
  jobFunction: ApiJobFunction | null | undefined;
  areaOfFocus: ApiAreaOfFocus | null | undefined;
  locale?: UserLocale | 'all';
};

export function CmsAmpRecommendedJobs({
  headline,
  layout,
  jobFunction,
  areaOfFocus,
  locale,
  source,
}: AmpCmsRecommendedJobsProps) {
  const queryParams: Record<string, string> = {};
  if (jobFunction) {
    queryParams.functions = jobFunction;
  }
  if (areaOfFocus) {
    queryParams.areasOfFocus = areaOfFocus;
  }
  if (locale && locale !== 'all') {
    queryParams.locale = locale;
  }
  let qs = '';
  if (!objectEmpty(queryParams)) {
    qs = `?${queryString.stringify(queryParams)}`;
  }
  return (
    <>
      <TileCarouselHeader
        layout={layout}
        // @ts-expect-error TS(2322): Type '{ layout: "SLIM" | "REGULAR"; source: "RECOM... Remove this comment to see the full error message
        source={source}
        headline={headline}
        linkNode={
          <AnchorButton
            href={`${listingSearchHomePath('JOB')}?${queryString.stringify(
              {
                q: '',
                functions: [jobFunction],
                areasOfFocus: [areaOfFocus],
                locale: locale === 'all' ? [] : [locale],
              },
              {
                skipNull: true,
              },
            )}`}
          >
            {getText('See All')}
          </AnchorButton>
        }
      />
      <Box mt={48}>
        <amp-list
          width="auto"
          height="200"
          layout="fixed-height"
          src={`/data/website/search/latest-jobs${qs}`}
          items="results"
          max-items="3"
        >
          <template type="amp-mustache">
            <CmsAmpRecommendedJobCard layout={layout} />
          </template>
        </amp-list>
      </Box>
    </>
  );
}
